import { useEffect } from 'react';

export default function NotFoundPage() {
  useEffect(() => {
    window.location.href = 'https://www.up2promo.com';
  }, []);

  return null;
}
